import axios from 'axios'
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/admin`

/**
 * [판매관리 > 발주확인/발송관리] 주문 유형별 갯수 조회
 * @param param
 * @param userId
 */
const salesManageStatus = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/order/status`, {
    params: param,
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * 주문 목록 조회
 * @param param
 * @param userId
 */
const searchOrderDetailList = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/order/detail/list`, {
    params: param,
    headers: {
      userId: userId,
    },
  })
  return res
}

const searchOrderOne = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/order/one`, {
    params: param,
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * 연락처로 이전 최신 주문건 조회
 * @param param
 * @param userId
 */
const getOrderOneByPhone = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/order/one/phone`, {
    params: param,
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * 반품 관련 주문 목록 정보 조회 (2023.07.21) - ksb
 * @param param
 * @param userId
 */
const getEtcReturnPriceSum = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/order/total-return-price`, {
    params: param,
    headers: {
      userId: userId,
    },
  })
  return res
}

// /**
//  * 단건 iamport 결제 정보 찾기
//  * @param {*} param
//  * @param {*} userId
//  * @returns
//  */

// const getPaymentSearchIamport = async (param, userId) => {
//   const res = await axios.get(`${baseUrl}/payment/search/iamport`, {
//     params: param,
//     headers: {
//       adminUserId: userId,
//     },
//   })
//   return res
// }

/**
 * 단건 DB 결제 정보 찾기
 * @param param
 * @param userId
 */

const getPaymentSearch = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/payment/search`, {
    params: param,
    headers: {
      adminUserId: userId,
    },
  })
  return res
}

const orderCreate = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/order/create`, param, {
    headers: {
      userId: userId,
    },
  })
  return res
}

const orderEdit = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/order/edit`, param, {
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * [판매관리 > 발주확인/발송관리] 주문 상태값 변경하기
 * @param param
 * @param userId
 */
const orderStatusEdit = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/order/edit/status`, param, {
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * [판매관리 > 주문통합검색] 무통장 입금 완료 처리
 * @param param
 * @param userId
 */
const orderStatusEditForDeposit = async (param, userId) => {
  const res = await axios.post(
    `${baseUrl}/order/edit/status/deposit-paid`,
    param,
    {
      headers: {
        userId: userId,
      },
    },
  )
  return res
}

/**
 * [판매관리 > 발주확인/발송관리] 송장 등록하기
 * @param param
 * @param userId
 */
const orderTrackingNumRegister = async (param, userId) => {
  const res = await axios.post(
    `${baseUrl}/order/register/tracking-number`,
    param,
    {
      headers: {
        userId: userId,
      },
    },
  )
  return res
}

/**
 * [판매관리 > 반품관리] 반송장 번호 입력
 * @param param
 * @param userId
 */
const postReturnTrackingNumber = async (param, userId) => {
  const res = await axios.post(
    `${baseUrl}/order/register/return/tracking-number`,
    param,
    {
      headers: {
        userId: userId,
      },
    },
  )
  return res
}

/**
 * 고객 배송지 정보 수정
 * @param param
 * @param userId
 */
const orderDeliveryInfoEdit = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/order/edit/delivery-info`, param, {
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * [주문통합검색] 수동주문생성건 배송지 정보 수정
 * @param param
 * @param userId
 */
const manualOrderDeliveryInfoEdit = async (param, userId) => {
  const res = await axios.post(
    `${baseUrl}/order/edit/manual-order/delivery-info`,
    param,
    {
      headers: {
        userId: userId,
      },
    },
  )
  return res
}

/**
 * 판매자 직접 취소처리
 * @param param
 * @param userId
 */
const orderDirectlyCancel = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/payment/cancel-all`, param, {
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * [판매관리 > 발주확인/발송관리] 취소처리
 * @param param
 * @param userId
 */
const orderCancelInfoEdit = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/order/edit/cancel-info`, param, {
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * [판매관리 > 반품관리] 추가 반품비용 청구 (2023.07.21) - ksb
 * @param param
 * @param userId
 */
const postEtcReturnPrice = async (param, userId) => {
  const res = await axios.post(
    `${baseUrl}/order/edit/etc-return-price`,
    param,
    {
      headers: {
        userId: userId,
      },
    },
  )
  return res
}

/**
 * [판매관리 > 반품관리] 환불 절차 진행
 * @param param
 * @param userId
 */
const postReturnPortOne = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/payment/cancel/return`, param, {
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * [판매관리 > 발주확인/발송관리] 송장 업로드가 가능한 주문건인지 확인
 * @param param
 * @param userId
 */
const isPossibleUploadTrackingNumber = async (param, userId) => {
  const res = await axios.post(
    `${baseUrl}/order/status/upload-tracking-number`,
    param,
    {
      headers: {
        userId: userId,
      },
    },
  )
  return res
}

/**
 * 해당 상세주문건이 주문아이디의 마지막 주문건인지 확인
 * @param param
 * @param userId
 */
const isLastOrderByOrderId = async (param, userId) => {
  const res = await axios.post(
    `${baseUrl}/order/detail/status/last-order-id`,
    param,
    {
      headers: {
        userId: userId,
      },
    },
  )
  return res
}

/**
 * 주문취소요청승인시 orderDetail이 있는지 여부 확인
 * @param param
 * @param userId
 */
const isLastOrder = async (param, userId) => {
  const res = await axios.post(
    `${baseUrl}/order/detail/status/last-seller`,
    param,
    {
      headers: {
        userId: userId,
      },
    },
  )
  return res
}

/**
 * 환불 가능한 주문건인지 확인
 * @param param
 * @param userId
 */
const refundableOrder = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/order/status/refundable`, param, {
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * 구매확정시 포인트 적힙하기
 * @param param
 * @param userId
 */
const purchasePointComplete = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/point/purchase-complete`, param, {
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * 구매시 사용한 포인트 환급처리
 * @param param
 * @param userId
 */
const purchasePointCancel = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/point/purchase-cancel`, param, {
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * 배송사 목록 조회
 * @param userId
 */
const deliveryCompanyList = async (userId) => {
  const res = await axios.get(`${baseUrl}/delivery-company/list`, {
    headers: {
      userId: userId,
    },
  })
  return res
}

const orderApi = {
  salesManageStatus,
  searchOrderDetailList,
  searchOrderOne,
  getOrderOneByPhone,
  getEtcReturnPriceSum,
  // getPaymentSearchIamport,
  // getPaymentSearchResult,
  getPaymentSearch,

  isPossibleUploadTrackingNumber,
  isLastOrderByOrderId,
  isLastOrder,
  refundableOrder,

  orderCreate,
  orderEdit,
  orderStatusEdit,
  orderStatusEditForDeposit,
  orderTrackingNumRegister,
  postReturnTrackingNumber,
  orderDeliveryInfoEdit,
  manualOrderDeliveryInfoEdit,

  orderDirectlyCancel,
  orderCancelInfoEdit,
  postEtcReturnPrice,
  postReturnPortOne,

  purchasePointComplete,
  purchasePointCancel,

  deliveryCompanyList,
}

export default orderApi
